import _defineProperty from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray";
import React from "react";
var __jsx = React.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/regenerator";

/* eslint-disable max-lines */
import { Button, TextField } from '@material-ui/core';
import omit from 'lodash/omit';
import { useRouter } from 'next/router';
import { useCallback, useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useAsyncFn } from 'react-use';
import { AffiliationBlockType, AffiliationOfferType, isAllOffersProductWithOffer } from '@uno/common-cms';
import { ImagePreview } from 'components/common/ImagePreview';
import Loader from 'components/common/Loader';
import { GradientButton } from 'components/common/material-ui/custom-components';
import { SearchProduct } from 'components/content/SearchProduct';
import { useSiteConfig, useSnackAsyncError } from 'libs/common/hooks';
import { createAffiliation, getAffiliationProducts, getProduct, updateAffiliation } from 'services/networking/affiliation';
import { ButtonContainer, Description, ImagePreviewContainer, InputContainer, InputTitle, LoaderContainer } from './AffiliationBlockTypePriceTable.style';
import SelectedItemAndRetailer from './SelectedItemAndRetailer/SelectedItemAndRetailer';

var AffiliationBlockTypePriceTable = function AffiliationBlockTypePriceTable(_ref) {
  var _initialLinkData$prod, _initialLinkData$prod2, _initialLinkData$prod3, _initialLinkData$prod4, _initialLinkData$prod5;

  var initialLinkData = _ref.initialLinkData,
      onConfirm = _ref.onConfirm;
  var router = useRouter();
  var contentId = router.query.id;

  var _useSiteConfig = useSiteConfig(),
      site = _useSiteConfig.id,
      lang = _useSiteConfig.lang;

  var intl = useIntl();

  var _useSnackAsyncError = useSnackAsyncError(),
      snackAsyncError = _useSnackAsyncError.snackAsyncError;

  var _useState = useState(''),
      searchText = _useState[0],
      setSearchText = _useState[1];

  var _useState2 = useState(undefined),
      selectedProduct = _useState2[0],
      setSelectedProduct = _useState2[1];

  var _useState3 = useState(false),
      selectedProductLoading = _useState3[0],
      setSelectedProductLoading = _useState3[1];

  var _useState4 = useState(initialLinkData === null || initialLinkData === void 0 ? void 0 : initialLinkData.title),
      tableTitle = _useState4[0],
      setTableTitle = _useState4[1];

  var _useState5 = useState(initialLinkData === null || initialLinkData === void 0 ? void 0 : (_initialLinkData$prod = initialLinkData.products) === null || _initialLinkData$prod === void 0 ? void 0 : (_initialLinkData$prod2 = _initialLinkData$prod[0]) === null || _initialLinkData$prod2 === void 0 ? void 0 : _initialLinkData$prod2.image),
      tableImage = _useState5[0],
      setTableImage = _useState5[1];

  var _useState6 = useState((_initialLinkData$prod3 = initialLinkData === null || initialLinkData === void 0 ? void 0 : (_initialLinkData$prod4 = initialLinkData.products) === null || _initialLinkData$prod4 === void 0 ? void 0 : (_initialLinkData$prod5 = _initialLinkData$prod4[0]) === null || _initialLinkData$prod5 === void 0 ? void 0 : _initialLinkData$prod5.retailerNumber) !== null && _initialLinkData$prod3 !== void 0 ? _initialLinkData$prod3 : 3),
      retailerNumber = _useState6[0],
      setRetailerNumber = _useState6[1];

  var _useState7 = useState((initialLinkData === null || initialLinkData === void 0 ? void 0 : initialLinkData.title) !== undefined),
      isTableTitleCustomized = _useState7[0],
      setIsTableTitleCustomized = _useState7[1];

  var updateSelectedProduct = function updateSelectedProduct(product) {
    setSelectedProduct(product);

    if (isTableTitleCustomized === true) {
      return;
    }

    setTableTitle(product.name);
  };

  var _useAsyncFn = useAsyncFn( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(affiliationId) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return snackAsyncError({
                messageId: 'affiliation.error.get-products',
                callback: function () {
                  var _callback = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                    var _yield$getAffiliation, products;

                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return getAffiliationProducts(lang, affiliationId, site);

                          case 2:
                            _yield$getAffiliation = _context.sent;
                            products = _yield$getAffiliation.products;

                            if (products[0] !== undefined) {
                              updateSelectedProduct(products[0]);
                            }

                          case 5:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  function callback() {
                    return _callback.apply(this, arguments);
                  }

                  return callback;
                }()
              });

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }()),
      _useAsyncFn2 = _slicedToArray(_useAsyncFn, 2),
      retrieveProductLoading = _useAsyncFn2[0].loading,
      retrieveProduct = _useAsyncFn2[1];

  useEffect(function () {
    if ((initialLinkData === null || initialLinkData === void 0 ? void 0 : initialLinkData.affiliationId) === undefined) {
      return;
    }

    void retrieveProduct(initialLinkData.affiliationId);
  }, [initialLinkData, retrieveProduct]);
  var handleConfirm = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
    var product, newBlockData;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            if (isAllOffersProductWithOffer(selectedProduct)) {
              _context5.next = 2;
              break;
            }

            return _context5.abrupt("return");

          case 2:
            product = omit(_objectSpread(_objectSpread({}, selectedProduct), {}, {
              maxDisplayedOffers: retailerNumber
            }), 'offers');

            newBlockData = function newBlockData(affiliationId) {
              return {
                affiliationId: affiliationId,
                title: tableTitle,
                type: AffiliationBlockType.PriceTable,
                products: [{
                  image: tableImage,
                  retailerNumber: retailerNumber
                }]
              };
            };

            if (!((initialLinkData === null || initialLinkData === void 0 ? void 0 : initialLinkData.affiliationId) === undefined)) {
              _context5.next = 8;
              break;
            }

            _context5.next = 7;
            return snackAsyncError({
              messageId: 'affiliation.error.create',
              callback: function () {
                var _callback2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
                  var _yield$createAffiliat, affiliationId;

                  return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          _context3.next = 2;
                          return createAffiliation(AffiliationOfferType.ALL_OFFERS, contentId, [product]);

                        case 2:
                          _yield$createAffiliat = _context3.sent;
                          affiliationId = _yield$createAffiliat.affiliationId;
                          onConfirm(newBlockData(affiliationId));

                        case 5:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                }));

                function callback() {
                  return _callback2.apply(this, arguments);
                }

                return callback;
              }(),
              errorCallback: function errorCallback() {
                onConfirm(null);
              }
            });

          case 7:
            return _context5.abrupt("return");

          case 8:
            _context5.next = 10;
            return snackAsyncError({
              messageId: 'affiliation.error.update',
              callback: function () {
                var _callback3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
                  return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                      switch (_context4.prev = _context4.next) {
                        case 0:
                          _context4.next = 2;
                          return updateAffiliation(initialLinkData.affiliationId, AffiliationOfferType.ALL_OFFERS, contentId, [product]);

                        case 2:
                          onConfirm(newBlockData(initialLinkData.affiliationId));

                        case 3:
                        case "end":
                          return _context4.stop();
                      }
                    }
                  }, _callee4);
                }));

                function callback() {
                  return _callback3.apply(this, arguments);
                }

                return callback;
              }()
            });

          case 10:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  })), [contentId, initialLinkData, onConfirm, retailerNumber, selectedProduct, snackAsyncError, tableImage, tableTitle]);

  var onProductClick = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(product, search) {
      var newSelectedProduct;
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              newSelectedProduct = {
                apiId: product.apiId,
                productId: product.productId,
                name: '',
                offers: []
              };
              setSelectedProductLoading(true);
              _context7.next = 4;
              return snackAsyncError({
                messageId: 'affiliation.error.get-product',
                callback: function () {
                  var _callback4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
                    var _yield$getProduct, name, offer;

                    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                      while (1) {
                        switch (_context6.prev = _context6.next) {
                          case 0:
                            _context6.next = 2;
                            return getProduct(lang, product.apiId, product.productId, site);

                          case 2:
                            _yield$getProduct = _context6.sent;
                            name = _yield$getProduct.name;
                            offer = _yield$getProduct.offer;
                            updateSelectedProduct(_objectSpread(_objectSpread({}, newSelectedProduct), {}, {
                              name: name,
                              offers: offer !== null ? [offer] : []
                            }));

                          case 6:
                          case "end":
                            return _context6.stop();
                        }
                      }
                    }, _callee6);
                  }));

                  function callback() {
                    return _callback4.apply(this, arguments);
                  }

                  return callback;
                }()
              });

            case 4:
              setSelectedProductLoading(false);
              setSearchText(search);

            case 6:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    return function onProductClick(_x2, _x3) {
      return _ref4.apply(this, arguments);
    };
  }();

  if (selectedProductLoading || retrieveProductLoading) {
    return __jsx(LoaderContainer, null, __jsx(Loader, null));
  }

  if (selectedProduct === undefined) {
    return __jsx(SearchProduct, {
      initialSearchText: searchText,
      onProductClick: onProductClick
    });
  }

  return __jsx(React.Fragment, null, __jsx(FormattedMessage, {
    id: "affiliation-table-modal.description",
    tagName: Description
  }), __jsx(InputContainer, null, __jsx(TextField, {
    id: "affiliation-block-modal-price-table-text",
    value: tableTitle,
    fullWidth: true,
    type: "text",
    onChange: function onChange(event) {
      setTableTitle(event.target.value);
      setIsTableTitleCustomized(true);
    },
    label: intl.formatMessage({
      id: 'affiliation-table-modal.labels.tableTitle'
    }),
    variant: "outlined"
  })), __jsx(FormattedMessage, {
    id: "affiliation-table-modal.tablePicture",
    tagName: InputTitle
  }), __jsx(ImagePreviewContainer, null, __jsx(ImagePreview, {
    imageData: tableImage,
    onConfirm: function onConfirm(imageData) {
      setTableImage(imageData);
    },
    onRemove: function onRemove() {
      return setTableImage(undefined);
    },
    onClickRemove: function onClickRemove() {
      return setTableImage(undefined);
    }
  })), __jsx(SelectedItemAndRetailer, {
    selectedProduct: selectedProduct,
    retailerNumber: retailerNumber,
    setRetailerNumber: setRetailerNumber
  }), __jsx(ButtonContainer, null, __jsx(Button, {
    variant: "outlined",
    color: "primary",
    onClick: function onClick() {
      return setSelectedProduct(undefined);
    }
  }, __jsx(FormattedMessage, {
    id: "affiliation-table-modal.change-product"
  })), __jsx(GradientButton, {
    disabled: !isAllOffersProductWithOffer(selectedProduct),
    onClick: handleConfirm
  }, __jsx(FormattedMessage, {
    id: "affiliation-table-modal.confirm"
  }))));
};

export default AffiliationBlockTypePriceTable;